import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from 'TMConstants';
import { themeObj } from 'TMComponents/GlobalStyle';
import Pill from 'TMComponents/Pill';
import GreenTick from 'TMComponents/Icons/GreenTick';
import tableData from './tableData';

const baseCardStyles = css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 350px;
    ${({ sizing }) => sizing && `width: ${sizing};`}

    max-width: 100%;
    min-height: 100%;
    box-sizing: border-box;
`;

const ColoredCard = styled.div``;

const CardBackground = styled.div`
    ${baseCardStyles}
    margin: 0 20px;

    @media (max-width: ${breakpoints.mobileTablet}px) {
        margin-left: 0;
        margin-right: 0;

        &:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    overflow: hidden;
`;

const Table = styled.table`
    margin: 0 auto;
    table-layout: fixed;
    box-sizing: border-box;
    border-collapse: separate;
    border-spacing: 5px;
    width: 575px;
`;

export const Th = styled.th`
    background-color: ${(props) =>
        props.$noBg
            ? 'transparent'
            : `${themeObj.colorSystem.UIElements[8]}`};
    padding: 1rem;
    text-align: ${(props) => (props.align ? props.align : 'center')};
    position: sticky;
    top: 0;
    z-index: 11; /* Ensure it's above scrollable content */

    // Hack fix, styled Pill didn't work
    > div {
        display: inline-block;
    }
`;

export const Td = styled.td`
    position: relative;
    background-color: ${themeObj.colorSystem.UIElements[8]};
    width: 75px;
    padding: 1rem;
    text-align: ${(props) => (props.align ? props.align : 'center')};
    font-weight: 500;
`;

const RowHeader = styled.td`
    width: 175px;
    padding: 1rem;
    background-color: ${(props) =>
        props.$noBg
            ? 'transparent'
            : `${themeObj.colorSystem.UIElements[8]}`};
    text-align: left;
`;

const RowHeaderSecondary = styled(RowHeader)`
    width: 163px; // Fix for table cell width offset
`;

const BgFill = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: ${themeObj.colorSystem.UIElements[4]};
`;

const Separator = styled.hr`
    width: 563px;
    margin: 20px auto;

    @media (max-width: ${breakpoints.mobileTablet}px) {
        margin-left: 5px; // Fix for table and seperator alignment, kill me
    }
`;

const renderCellContent = (value) => {
    switch (value) {
        case 'icon--check':
            return <GreenTick />;
        case 'bgColor':
            return <BgFill />;
        default:
            // eslint-disable-next-line react/no-danger
            return <span dangerouslySetInnerHTML={{ __html: value }} />;
    }
};

const ComparisonTable = () => {
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <RowHeader $noBg align="left" />
                        <Th $noBg>
                            <Pill variant="standard" size="small" />
                        </Th>
                        <Th $noBg>
                            <Pill variant="popular" size="small" />
                        </Th>
                        <Th $noBg>
                            <Pill variant="premium" size="small" />
                        </Th>
                    </tr>
                    <tr>
                        <RowHeader>
                            <strong>Account features</strong>
                        </RowHeader>
                        <Th>Everyday</Th>
                        <Th>Smart</Th>
                        <Th>SmartPlus</Th>
                    </tr>
                </thead>

                <tbody>
                    {tableData.map((item) => (
                        <tr key={item[0]}>
                            <RowHeader
                                dangerouslySetInnerHTML={{
                                    __html: item[0]
                                }}
                            />
                            <Td>{renderCellContent(item[1])}</Td>
                            <Td>{renderCellContent(item[2])}</Td>
                            <Td>{renderCellContent(item[3])}</Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Separator />
            <Table>
                <tbody>
                    <tr>
                        <RowHeaderSecondary>
                            <strong>Monthly Fee</strong>
                        </RowHeaderSecondary>
                        <Td>FREE</Td>
                        <Td>&pound;12.50</Td>
                        <Td>&pound;15.95</Td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};

const FlexibleCard = styled(CardBackground)`
    background-color: ${themeObj.colorSystem.UIElements[5]};
    overflow-x: scroll;
`;

const CompareAccountsTable = () => {
    return (
        <FlexibleCard sizing="890px" hasImage={false}>
            <ColoredCard>
                <ComparisonTable />
            </ColoredCard>
        </FlexibleCard>
    );
};

export default CompareAccountsTable;
